import '../../css/FormTemplate.css'
import { IFormSelectInternalDivTemplate } from "../../interfaces/interface";
import FormTemplateLabel from './FormTemplateLabel';

const FormSelectInternalDivTemplate = (props:IFormSelectInternalDivTemplate) => {

    return (              
            <div className={props.errorSpace ? "form-template-internal-div error-space" : "form-template-internal-div"}>
                <FormTemplateLabel id={props.id} label={props.label} dataToolTip={props.dataToolTip}/>
                <div className='form-template-input-div-without-icon' >
                    <select className="form-template-input-select" 
                        name={props.id}
                        id={props.id} 
                        onChange={props.selectChangeHandler}
                        disabled={props.disabled}
                    >
                        <option selected className="form-template-select-option" value="">
                            {props.placeHolder}
                        </option>
                        { 
                            props.optionList &&
                                props.optionList.map((option) => 
                                    <option className="form-template-select-option" value={option}>{option}</option>
                                )
                        }
                    </select>
                </div>
            </div>
    );
};

export default FormSelectInternalDivTemplate;